var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M8.32422 54.2996C8.32422 54.5557 8.91299 54.8093 10.0569 55.0458C11.2008 55.2824 12.8775 55.4974 14.9912 55.6785C17.1049 55.8595 19.6142 56.0032 22.3759 56.1012C25.1376 56.1992 28.0975 56.2496 31.0867 56.2496C34.0759 56.2496 37.0359 56.1992 39.7976 56.1012C42.5592 56.0032 45.0685 55.8595 47.1822 55.6785C49.2959 55.4974 50.9726 55.2824 52.1165 55.0458C53.2605 54.8093 53.8492 54.5557 53.8492 54.2996C53.8492 54.0435 53.2605 53.79 52.1165 53.5534C50.9726 53.3168 49.2959 53.1018 47.1822 52.9208C45.0685 52.7397 42.5592 52.596 39.7976 52.498C37.0359 52.4 34.0759 52.3496 31.0867 52.3496C28.0975 52.3496 25.1376 52.4 22.3759 52.498C19.6142 52.596 17.1049 52.7397 14.9912 52.9208C12.8775 53.1018 11.2008 53.3168 10.0569 53.5534C8.91299 53.79 8.32422 54.0435 8.32422 54.2996Z",
    fill: "#45413C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90234 26.8925L46.3098 8.34375L58.0886 36.545L13.6823 55.095L1.90234 26.8925Z",
    fill: "#FFE500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9109 9.35039L4.31094 25.9004C3.67442 26.1656 3.16933 26.6728 2.90677 27.3104C2.64422 27.9481 2.64572 28.6639 2.91094 29.3004L4.53594 33.2004C4.40462 32.8852 4.33666 32.5473 4.33594 32.2058C4.33523 31.8644 4.40177 31.5262 4.53177 31.2104C4.66178 30.8947 4.85269 30.6077 5.09362 30.3658C5.33454 30.1238 5.62077 29.9317 5.93594 29.8004L45.5359 13.2504C46.1746 12.9881 46.8908 12.988 47.5295 13.25C48.1682 13.5121 48.678 14.0152 48.9484 14.6504L47.3109 10.7504C47.0457 10.1139 46.5385 9.60878 45.9009 9.34623C45.2633 9.08368 44.5475 9.08517 43.9109 9.35039Z",
    fill: "#FFF48C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90234 26.8925L46.3098 8.34375L58.0886 36.545L13.6823 55.095L1.90234 26.8925Z",
    stroke: "#45413C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 32.8957L48.8294 14.3457L51.0831 19.7457L6.67688 38.292L4.42188 32.8957Z",
    fill: "#656769",
    stroke: "#45413C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 38.0416L49.3344 24.0078L50.8369 27.6066L17.2369 41.6403L15.7344 38.0416Z",
    fill: "white",
    stroke: "#45413C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0391 33.2621L51.8353 30.0059L53.8403 34.8034L46.0428 38.0609L44.0391 33.2621Z",
    fill: "#DAEDF7",
    stroke: "#45413C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3242 44.9871L29.5367 40.7246M33.7367 38.9746L38.5367 36.9746",
    stroke: "#45413C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit_card_icon.77ef09df0981fd55261f66a0f25d4fa2.svg";
export { ForwardRef as ReactComponent };